import React, { useEffect } from 'react'
import { Form, Field } from 'redux-form'

import { vEmail, vMobilePhone, vNotEmpty } from 'components/Input/Input.validations'

import InputWithConfirm from '../InputWithConfirm'

export default props => {
  const { allConfirmed, startAutoRefresh, stopAutoRefresh, stopDelay } = props

  useEffect(() => {
    allConfirmed ? stopAutoRefresh() : startAutoRefresh()
  }, [allConfirmed])

  useEffect(() => {
    return () => {
      // stop all on exit
      stopAutoRefresh() &&
        stopDelay('emailConfirmationDelay') &&
        stopDelay('phoneConfirmationDelay')
    }
  }, [])

  return (
    <Form onSubmit={() => {}}>
      <Field
        name="email"
        component={InputWithConfirm}
        type="email"
        label="Email"
        hideDot
        validate={[vNotEmpty, vEmail]}
      />

      <Field
        name="phone"
        component={InputWithConfirm}
        label="Mobile Phone Number"
        type="tel"
        hideDot
        validate={[vNotEmpty, vMobilePhone]}
      />
    </Form>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/VerificationForm/VerificationForm.jsx